module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-form', [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm6": "",
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome",
      "error-messages": _vm.pessoaNomeErros,
      "required": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.data.pessoa.nome.$touch()
      },
      "blur": function($event) {
        return _vm.$v.data.pessoa.nome.$touch()
      }
    },
    model: {
      value: (_vm.data.pessoa.nome),
      callback: function($$v) {
        _vm.$set(_vm.data.pessoa, "nome", $$v)
      },
      expression: "data.pessoa.nome"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md3": "",
      "sm6": "",
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.dependencias.tipos_sexo,
      "error-messages": _vm.pessoaFisicaSexoErros,
      "label": "Sexo",
      "clearable": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.data.pessoa_fisica.sexo.$touch()
      },
      "blur": function($event) {
        return _vm.$v.data.pessoa_fisica.sexo.$touch()
      }
    },
    model: {
      value: (_vm.data.pessoa_fisica.sexo),
      callback: function($$v) {
        _vm.$set(_vm.data.pessoa_fisica, "sexo", $$v)
      },
      expression: "data.pessoa_fisica.sexo"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md3": "",
      "sm6": "",
      "xs12": ""
    }
  }, [_c('v-menu', {
    ref: "datepickerDtNascimento",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "max-width": "290px",
      "min-width": "290px"
    },
    model: {
      value: (_vm.mostrarDatepickerDtNascimento),
      callback: function($$v) {
        _vm.mostrarDatepickerDtNascimento = $$v
      },
      expression: "mostrarDatepickerDtNascimento"
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('##/##/####'),
      expression: "'##/##/####'"
    }],
    attrs: {
      "slot": "activator",
      "label": "Data de Nascimento",
      "prepend-icon": "event"
    },
    on: {
      "blur": _vm.formatarDataNascimento
    },
    slot: "activator",
    model: {
      value: (_vm.data.pessoa_fisica.dt_nascimento_formatada),
      callback: function($$v) {
        _vm.$set(_vm.data.pessoa_fisica, "dt_nascimento_formatada", $$v)
      },
      expression: "data.pessoa_fisica.dt_nascimento_formatada"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "error-messages": _vm.pessoaFisicaDtNascimentoErros,
      "locale": "pt-br"
    },
    on: {
      "input": _vm.formatarDataNascimento,
      "blur": _vm.formatarDataNascimento
    },
    model: {
      value: (_vm.data.pessoa_fisica.dt_nascimento),
      callback: function($$v) {
        _vm.$set(_vm.data.pessoa_fisica, "dt_nascimento", $$v)
      },
      expression: "data.pessoa_fisica.dt_nascimento"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm6": "",
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "CPF",
      "error-messages": _vm.pessoaFisicaCpfErros,
      "mask": "###.###.###-##",
      "required": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.data.pessoa_fisica.cpf.$touch()
      },
      "blur": function($event) {
        return _vm.$v.data.pessoa_fisica.cpf.$touch()
      }
    },
    model: {
      value: (_vm.data.pessoa_fisica.cpf),
      callback: function($$v) {
        _vm.$set(_vm.data.pessoa_fisica, "cpf", $$v)
      },
      expression: "data.pessoa_fisica.cpf"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm6": "",
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "RG",
      "error-messages": _vm.pessoaFisicaRgNumeroErros,
      "required": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.data.pessoa_fisica.rg_numero.$touch()
      },
      "blur": function($event) {
        return _vm.$v.data.pessoa_fisica.rg_numero.$touch()
      }
    },
    model: {
      value: (_vm.data.pessoa_fisica.rg_numero),
      callback: function($$v) {
        _vm.$set(_vm.data.pessoa_fisica, "rg_numero", $$v)
      },
      expression: "data.pessoa_fisica.rg_numero"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm6": "",
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome da Mãe",
      "error-messages": _vm.pessoaFisicaNomeMaeErros,
      "required": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.data.pessoa_fisica.nome_mae.$touch()
      },
      "blur": function($event) {
        return _vm.$v.data.pessoa_fisica.nome_mae.$touch()
      }
    },
    model: {
      value: (_vm.data.pessoa_fisica.nome_mae),
      callback: function($$v) {
        _vm.$set(_vm.data.pessoa_fisica, "nome_mae", $$v)
      },
      expression: "data.pessoa_fisica.nome_mae"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md3": "",
      "sm6": "",
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.dependencias.estados_civis,
      "item-value": "id",
      "item-text": "descricao",
      "error-messages": _vm.pessoaFisicaRefEstadoCivilErros,
      "label": "Estado civil",
      "clearable": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.data.pessoa_fisica.ref_estado_civil.$touch()
      },
      "blur": function($event) {
        return _vm.$v.data.pessoa_fisica.ref_estado_civil.$touch()
      }
    },
    model: {
      value: (_vm.data.pessoa_fisica.ref_estado_civil),
      callback: function($$v) {
        _vm.$set(_vm.data.pessoa_fisica, "ref_estado_civil", $$v)
      },
      expression: "data.pessoa_fisica.ref_estado_civil"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md3": "",
      "sm6": "",
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.dependencias.racas,
      "item-value": "id",
      "item-text": "descricao",
      "error-messages": _vm.pessoaFisicaRefRacaErros,
      "label": "Etnia",
      "clearable": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.data.pessoa_fisica.ref_raca.$touch()
      },
      "blur": function($event) {
        return _vm.$v.data.pessoa_fisica.ref_raca.$touch()
      }
    },
    model: {
      value: (_vm.data.pessoa_fisica.ref_raca),
      callback: function($$v) {
        _vm.$set(_vm.data.pessoa_fisica, "ref_raca", $$v)
      },
      expression: "data.pessoa_fisica.ref_raca"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md4": "",
      "sm6": "",
      "xs12": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "error-messages": _vm.pessoaFisicaRefNaturalidadeErros,
      "items": _vm.dependencias.cidades_naturalidade,
      "loading": _vm.buscandoCidades,
      "search-input": _vm.buscarNaturalidade,
      "item-text": "nome",
      "item-value": "id",
      "label": "Naturalidade",
      "placeholder": "Digite o nome da cidade",
      "no-data-text": "Nenhum registro encontrado",
      "hide-no-data": "",
      "hide-selected": "",
      "clearable": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.data.pessoa_fisica.ref_naturalidade.$touch()
      },
      "blur": function($event) {
        return _vm.$v.data.pessoa_fisica.ref_naturalidade.$touch()
      },
      "update:searchInput": function($event) {
        _vm.buscarNaturalidade = $event
      },
      "update:search-input": function($event) {
        _vm.buscarNaturalidade = $event
      }
    },
    model: {
      value: (_vm.data.pessoa_fisica.ref_naturalidade),
      callback: function($$v) {
        _vm.$set(_vm.data.pessoa_fisica, "ref_naturalidade", $$v)
      },
      expression: "data.pessoa_fisica.ref_naturalidade"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md4": "",
      "sm6": "",
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.dependencias.paises,
      "error-messages": _vm.pessoaFisicaRefNacionalidadeErros,
      "item-value": "id",
      "item-text": "nome",
      "label": "Nacionalidade",
      "clearable": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.data.pessoa_fisica.ref_nacionalidade.$touch()
      },
      "blur": function($event) {
        return _vm.$v.data.pessoa_fisica.ref_nacionalidade.$touch()
      }
    },
    model: {
      value: (_vm.data.pessoa_fisica.ref_nacionalidade),
      callback: function($$v) {
        _vm.$set(_vm.data.pessoa_fisica, "ref_nacionalidade", $$v)
      },
      expression: "data.pessoa_fisica.ref_nacionalidade"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md4": "",
      "sm6": "",
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.dependencias.tipos_sanguineos,
      "label": "Tipo Sanguíneo",
      "clearable": ""
    },
    model: {
      value: (_vm.data.pessoa_fisica.tipo_sanguineo),
      callback: function($$v) {
        _vm.$set(_vm.data.pessoa_fisica, "tipo_sanguineo", $$v)
      },
      expression: "data.pessoa_fisica.tipo_sanguineo"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm3": "",
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "error-messages": _vm.pessoaCepErros,
      "mask": "#####-###",
      "label": "CEP",
      "required": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.data.pessoa.cep.$touch()
      },
      "blur": function($event) {
        return _vm.$v.data.pessoa.cep.$touch()
      }
    },
    model: {
      value: (_vm.data.pessoa.cep),
      callback: function($$v) {
        _vm.$set(_vm.data.pessoa, "cep", $$v)
      },
      expression: "data.pessoa.cep"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm6": "",
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "error-messages": _vm.pessoaRuaErros,
      "label": "Rua",
      "required": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.data.pessoa.rua.$touch()
      },
      "blur": function($event) {
        return _vm.$v.data.pessoa.rua.$touch()
      }
    },
    model: {
      value: (_vm.data.pessoa.rua),
      callback: function($$v) {
        _vm.$set(_vm.data.pessoa, "rua", $$v)
      },
      expression: "data.pessoa.rua"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm3": "",
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "error-messages": _vm.pessoaNumeroErros,
      "label": "Número",
      "required": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.data.pessoa.numero.$touch()
      },
      "blur": function($event) {
        return _vm.$v.data.pessoa.numero.$touch()
      }
    },
    model: {
      value: (_vm.data.pessoa.numero),
      callback: function($$v) {
        _vm.$set(_vm.data.pessoa, "numero", $$v)
      },
      expression: "data.pessoa.numero"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm4": "",
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Complemento"
    },
    model: {
      value: (_vm.data.pessoa.complemento),
      callback: function($$v) {
        _vm.$set(_vm.data.pessoa, "complemento", $$v)
      },
      expression: "data.pessoa.complemento"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm4": "",
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "error-messages": _vm.pessoaBairroErros,
      "label": "Bairro",
      "required": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.data.pessoa.bairro.$touch()
      },
      "blur": function($event) {
        return _vm.$v.data.pessoa.bairro.$touch()
      }
    },
    model: {
      value: (_vm.data.pessoa.bairro),
      callback: function($$v) {
        _vm.$set(_vm.data.pessoa, "bairro", $$v)
      },
      expression: "data.pessoa.bairro"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm4": "",
      "xs12": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "error-messages": _vm.pessoaRefCidadeErros,
      "items": _vm.dependencias.cidades,
      "loading": _vm.buscandoCidades,
      "search-input": _vm.buscarCidade,
      "item-text": "nome",
      "item-value": "id",
      "label": "Cidade",
      "placeholder": "Digite o nome da cidade",
      "no-data-text": "Nenhum registro encontrado",
      "hide-no-data": "",
      "hide-selected": "",
      "clearable": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.data.pessoa.ref_cidade.$touch()
      },
      "blur": function($event) {
        return _vm.$v.data.pessoa.ref_cidade.$touch()
      },
      "update:searchInput": function($event) {
        _vm.buscarCidade = $event
      },
      "update:search-input": function($event) {
        _vm.buscarCidade = $event
      }
    },
    model: {
      value: (_vm.data.pessoa.ref_cidade),
      callback: function($$v) {
        _vm.$set(_vm.data.pessoa, "ref_cidade", $$v)
      },
      expression: "data.pessoa.ref_cidade"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md3": "",
      "sm6": "",
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "error-messages": _vm.pessoaFisicaFoneResidencialErros,
      "mask": "(##) ####-####",
      "label": "Telefone Residencial"
    },
    on: {
      "input": function($event) {
        return _vm.$v.data.pessoa_fisica.fone_residencial.$touch()
      },
      "blur": function($event) {
        return _vm.$v.data.pessoa_fisica.fone_residencial.$touch()
      }
    },
    model: {
      value: (_vm.data.pessoa_fisica.fone_residencial),
      callback: function($$v) {
        _vm.$set(_vm.data.pessoa_fisica, "fone_residencial", $$v)
      },
      expression: "data.pessoa_fisica.fone_residencial"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md3": "",
      "sm6": "",
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "error-messages": _vm.pessoaFisicaFoneCelularErros,
      "mask": "(##) #####-####",
      "label": "Telefone Celular"
    },
    on: {
      "input": function($event) {
        return _vm.$v.data.pessoa_fisica.fone_celular.$touch()
      },
      "blur": function($event) {
        return _vm.$v.data.pessoa_fisica.fone_celular.$touch()
      }
    },
    model: {
      value: (_vm.data.pessoa_fisica.fone_celular),
      callback: function($$v) {
        _vm.$set(_vm.data.pessoa_fisica, "fone_celular", $$v)
      },
      expression: "data.pessoa_fisica.fone_celular"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md3": "",
      "sm6": "",
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "error-messages": _vm.pessoaFisicaFoneProfissionalErros,
      "mask": "(##) ####-####",
      "label": "Telefone Profissional"
    },
    on: {
      "input": function($event) {
        return _vm.$v.data.pessoa_fisica.fone_profissional.$touch()
      },
      "blur": function($event) {
        return _vm.$v.data.pessoa_fisica.fone_profissional.$touch()
      }
    },
    model: {
      value: (_vm.data.pessoa_fisica.fone_profissional),
      callback: function($$v) {
        _vm.$set(_vm.data.pessoa_fisica, "fone_profissional", $$v)
      },
      expression: "data.pessoa_fisica.fone_profissional"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md3": "",
      "sm6": "",
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "error-messages": _vm.pessoaFisicaFoneRecadoErros,
      "label": "Telefone de Recado"
    },
    on: {
      "input": function($event) {
        return _vm.$v.data.pessoa_fisica.fone_recado.$touch()
      },
      "blur": function($event) {
        return _vm.$v.data.pessoa_fisica.fone_recado.$touch()
      }
    },
    model: {
      value: (_vm.data.pessoa_fisica.fone_recado),
      callback: function($$v) {
        _vm.$set(_vm.data.pessoa_fisica, "fone_recado", $$v)
      },
      expression: "data.pessoa_fisica.fone_recado"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm6": "",
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "E-mail Principal",
      "error-messages": _vm.pessoaEmailErros,
      "required": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.data.pessoa.email.$touch()
      },
      "blur": function($event) {
        return _vm.$v.data.pessoa.email.$touch()
      }
    },
    model: {
      value: (_vm.data.pessoa.email),
      callback: function($$v) {
        _vm.$set(_vm.data.pessoa, "email", $$v)
      },
      expression: "data.pessoa.email"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm6": "",
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "error-messages": _vm.pessoaEmailAlternativoErros,
      "label": "E-mail Alternativo"
    },
    on: {
      "input": function($event) {
        return _vm.$v.data.pessoa.email_alternativo.$touch()
      },
      "blur": function($event) {
        return _vm.$v.data.pessoa.email_alternativo.$touch()
      }
    },
    model: {
      value: (_vm.data.pessoa.email_alternativo),
      callback: function($$v) {
        _vm.$set(_vm.data.pessoa, "email_alternativo", $$v)
      },
      expression: "data.pessoa.email_alternativo"
    }
  })], 1)], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "success",
      "disabled": _vm.botaoClicado || _vm.$v.data.pessoa.$invalid || _vm.$v.data.pessoa_fisica.$invalid
    },
    on: {
      "click": function($event) {
        return _vm.salvarDados()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-check"
  }), _vm._v(" "), _c('span', {
    staticClass: "pl-2"
  }, [_vm._v("Salvar Dados")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-643bdde4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/domains/pessoal/components/minha-conta/editar-meus-dados/DadosCadastrais.vue
// module id = 555
// module chunks = 2